import React, { PureComponent } from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import { Elements } from 'react-stripe-elements'
import PaymentForm from './PaymentForm'
import CardBasic from '../../../pricing_cards/components/CardBasic'
import { withRouter } from 'react-router-dom'

class PaymentCard extends PureComponent {
  render () {
    return (
      <div style={{ width: '100%' }}>
        <Card>
          <CardBody className='responsivePayment'>
            <Col className='paymentInfo'>
              <div className='payment'>
                <Elements>
                  <PaymentForm />
                </Elements>
              </div>
            </Col>
            <Col className='plan'>
              <div style={{ width: '100%' }}>
                <CardBasic
                  showButton={false}
                  className='paymentForm'
                  style={{ maxWidth: '100% !important' }}
                  name={this.props.location.state.name}
                  price={this.props.location.state.price}
                  features={this.props.location.state.features}
                  src={this.props.location.state.src} />
              </div>
            </Col>
          </CardBody>
        </Card>
      </div>
    )
  }
}
export default withRouter(PaymentCard)



// WEBPACK FOOTER //
// ./src/components/e-commerce/payment/components/PaymentCard.js